import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../services/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401) {
                // auto logout if 401 response returned from api
                this.authenticationService.logout();
                location.reload();
            }

            // Extract error message from Strapi error structure
            let errorMessage = err.statusText || 'Error desconocido';

            // Strapi v5 error format: { data: null, error: { message: "..." } }
            if (err.error?.error?.message) {
                const strapiMessage = err.error.error.message;

                // Translate common error messages
                if (strapiMessage.includes('Invalid identifier or password')) {
                    errorMessage = 'Correo o contraseña incorrectos';
                } else if (strapiMessage.includes('Your account email is not confirmed')) {
                    errorMessage = 'Tu cuenta no ha sido confirmada. Revisa tu correo electrónico.';
                } else if (strapiMessage.includes('blocked')) {
                    errorMessage = 'Tu cuenta ha sido bloqueada. Contacta al administrador.';
                } else {
                    errorMessage = strapiMessage;
                }
            } else if (err.error?.message) {
                // Fallback for other error formats
                errorMessage = err.error.message;
            }

            return throwError(() => errorMessage);
        }))
    }
}
